// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as EditOrderRepoConfig from "./EditOrderRepoConfig.bs.js";

var dummyManualEditOrderReasonsResponse = {
	reasons: [
		{
			id: 1,
			reason: "device issue"
		},
		{
			id: 2,
			reason: "network issue"
		}
	]
};

var dummyOrderCancellationReasons = {
    "reasons_for_customers": [
        {
            "id": 82,
            "name": "Client requested holiday"
        },
        {
            "id": 121,
            "name": "Driver is asking for more money"
        },
        {
            "id": 120,
            "name": "Driver is not cooperative"
        },
        {
            "id": 119,
            "name": "Expected a shorter arrival time"
        },
        {
            "id": 74,
            "name": "Driver is unprofessional"
        },
        {
            "id": 130,
            "name": "Partner device issue"
        },
        {
            "id": 31,
            "name": "Union Issue"
        },
        {
            "id": 53,
            "name": "Wrong/Inappropriate Vehicle"
        },
        {
            "id": 15,
            "name": "Duplicate order placed by Customer"
        }
    ],
    "reasons_for_drivers": [
        {
            "id": 32,
            "name": "Overloading/oversizing/unacceptable goods"
        },
        {
            "id": 83,
            "name": "Partner device issue"
        },
        {
            "id": 124,
            "name": "Credit/Instamojo/Paytm Trip"
        },
        {
            "id": 125,
            "name": "Long trip engagement"
        },
        {
            "id": 126,
            "name": "No entry/No parking/RTO issue"
        },
        {
            "id": 63,
            "name": "Partner refuses/personal work"
        },
        {
            "id": 21,
            "name": "Vehicle Breakdown"
        },
        {
            "id": 154,
            "name": "Union Issue"
        }
    ],
    "reasons_for_allocation": [
        {
            "id": 71,
            "name": "Test Order"
        },
        {
            "id": 78,
            "name": "Fake Order"
        },
        {
            "id": 79,
            "name": "Duplicate order placed by System"
        }
    ]
};

var updateSuccessfulResponse = {
        "title":"Success",
        "message":"update successful"
};

function fetchManualEditOrderReasons(country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyManualEditOrderReasonsResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.ManualEditOrderReasonsResponseConverter.execute, result);
                            });
                }), "fetchManualEditOrderReasons");
}

function fetchOrderCancellationReasons(_payload, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyOrderCancellationReasons
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.OrderCancellationReasonsResponseConverter.execute, result);
                            });
                }), "fetchOrderCancellationReasons");
}

function updateActualPartnerCollectedCash(_payload, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: updateSuccessfulResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateActualPartnerCollectedCashResponseConverter.execute, result);
                            });
                }), "updateActualPartnerCollectedCash");
}

function updateHasWaypoints(_payload, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: updateSuccessfulResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateHasWaypointsResponseConverter.execute, result);
                            });
                }), "updateHasWaypoints");
}

function updateDryRunDistance(_payload, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: updateSuccessfulResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateDryRunDistanceResponseConverter.execute, result);
                            });
                }), "updateDryRunDistance");
}

function updateOrderStatus(_payload, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: updateSuccessfulResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateOrderStatusResponseConverter.execute, result);
                            });
                }), "updateOrderStatus");
}

function cancelOrder(_payload, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: updateSuccessfulResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.CancelOrderResponseConverter.execute, result);
                            });
                }), "cancelOrder");
}

function updateDeliveryNote(_payload, _country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: updateSuccessfulResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(EditOrderRepoConfig.UpdateDeliveryNoteResponseConverter.execute, result);
                            });
                }), "updateDeliveryNote");
}

var EditOrderRepo = {
  fetchManualEditOrderReasons: fetchManualEditOrderReasons,
  fetchOrderCancellationReasons: fetchOrderCancellationReasons,
  updateActualPartnerCollectedCash: updateActualPartnerCollectedCash,
  updateHasWaypoints: updateHasWaypoints,
  updateDryRunDistance: updateDryRunDistance,
  updateOrderStatus: updateOrderStatus,
  cancelOrder: cancelOrder,
  updateDeliveryNote: updateDeliveryNote
};

export {
  EditOrderRepo ,
  
}
/* NetworkUtils Not a pure module */
